<template>
    <a-row :gutter="24">
      <a-col :md="24">
        <a-card :style="cardStyle1" :bordered="false">
          <!-- 查询区域 -->
          <div class="table-page-search-wrapper">
            <!-- 搜索区域 -->
            <a-form layout="inline" @keyup.enter.native="searchQuery">
              <a-row :gutter="24">
                <a-col :md="8" :lg="6"  :sm="24">
                  <a-form-item label="名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-input placeholder="请输入名称查询" v-model="queryParam.dicName"></a-input>
                  </a-form-item>
                </a-col>
                <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                  <a-col :md="8" :lg="6"  :sm="24">
                    <a-button type="primary" @click="searchQuery">查询</a-button>
                    <a-button style="margin-left: 8px" @click="searchReset">重置</a-button>
                  </a-col>
                </span>
              </a-row>
            </a-form>
          </div>
          <!-- 操作按钮区域 -->
          <div class="table-operator" style="margin-top: 5px">
            
            <a-button @click="handleAddDict" type="primary" icon="plus">添加</a-button>
          </div>
          <!-- table区域-begin -->
          <div>
            <a-table ref="table" size="middle" bordered rowKey="id" :columns="columns" :dataSource="dataSource" :pagination="ipagination" :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange ,columnWidth:'3%'}" :scroll="{ x: 500 }" :loading="loading" @change="handleTableChange">
              <span slot="action" slot-scope="text, record">
                <!-- <a @click="handleAddInfo(record)">添加字典内容</a>
                <a-divider type="vertical" /> -->
                <a @click="handleEdit(record)">编辑</a>
                <a-divider type="vertical" />
                <a @click="delConfirm(handleDelete,record.id)">删除</a>
              </span>
            </a-table>
          </div>
          <!-- table区域-end -->
          <!-- 表单区域 -->
         <add-dict-modal ref="addDictModal" @close="handleClose"></add-dict-modal>
         <add-dict-info ref="addDictInfo" @close="handleInfoClose"></add-dict-info>
        </a-card>
      </a-col>
    </a-row>
  </template>
  <!-- b y 7 5 2 7  1 8 9 2 0 -->
  <script>
  import AddDictModal from './modules/addDictModal'
  import AddDictInfo from './modules/addDictInfo'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import JDate from '@/components/jeecg/JDate'
  import { dictList, dictionaryDataList, dictDelete } from '@/api/api'
  import Vue from 'vue'
  export default {
    name: 'VendorList',
    mixins: [JeecgListMixin],
    components: {
      AddDictModal,
      AddDictInfo
    },
    data() {
      return {
        labelCol: {
          span: 5,
        },
        wrapperCol: {
          span: 18,
          offset: 1,
        },
        // 查询条件
        queryParam: {},
        ipagination: {
          current: 1,
          pageSize: 10,
          pageSizeOptions: ['10', '20', '30', '50', '100'],
          showTotal: (total, range) => {
            return range[0] + '-' + range[1] + ' 共' + total + '条'
          },
          showQuickJumper: true,
          showSizeChanger: true,
          total: 0,
        },
        // 表头
        columns: [
          { title: '字典名称', dataIndex: 'dicName', width: 70, align: 'left' },
          { title: '字典编码', dataIndex: 'dicCode', width: 70, align: 'left' },
          { title: '上级字典', dataIndex: 'parantDicName', width: 70, align: 'left' },
          // {
          //   title: '字典类型',
          //   dataIndex: 'dicType',
          //   width: 100,
          //   align: 'left',
          // },
          {
            title: '操作',
            dataIndex: 'action',
            width: 80,
            align: 'center',
            scopedSlots: { customRender: 'action' },
          },
        ],
        url: {
          list: '',
          delete: '/unit/certificateDelete',
          deleteBatch: '/supplier/deleteBatch',
          importExcelUrl: '/supplier/importVendor',
          exportXlsUrl: '/supplier/exportExcel',
          batchSetStatusUrl: '/supplier/batchSetStatus',
        },
      }
    },
    computed: {
      importExcelUrl: function () {
        return `${window._CONFIG['domianURL']}${this.url.importExcelUrl}`
      },
    },
    created() {},
    mounted() {
      this.getDictList()
    },
    methods: {
      // 获取字典列表
      async getDictList() {
        const params = {
          pageNo: this.ipagination.current,
          pageSize: this.ipagination.pageSize,
          dicType: 'TRACE_GOODS_CATEGORY',
          dicName: this.queryParam.dicName
        }
          const res = await dictList(params)
          if( res.code == 200 && res.success == true ){
            this.dataSource = res.result.records
            this.ipagination.total = res.result.total
          } else {
            this.$message.error(res.data || res.message)
          }
      },
      // 查询
      searchQuery(){
        this.getDictList()
      },
      handleClose(){
        this.getDictList()
      },
      handleInfoClose(){

      },
      // 添加字典
      handleAddDict(){
        this.$refs.addDictModal.show()
      },
      // 删除
      async handleDelete(id) {
        const res = await dictDelete({ id })
        console.log(res, 'res')
        if (res.code == 200 && res.success == true ) {
          this.$message.success(res.result)
          this.getDictList()
        } else {
          this.$message.error(res.data || res.message)
        }
      },
      searchReset() {
        this.queryParam = {
          // type: '供应商',
        }
        this.loadData(1)
      },
      handleEdit: function (record) {
        this.$refs.addDictModal.show(record)
      },
      // 添加字典内容
      handleAddInfo(record){
        this.$refs.addDictInfo.show(record)
      },
    },
  }
  </script>
  <style scoped>
  @import '~@assets/less/common.less';
  </style>